import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "./swgfl/javascript/accessibility.js";

// framework
import cookies from "./swgfl/cookies/javascript/cookies.js";
import security from "./swgfl/security/javascript/all.js";
import cms from "./swgfl/cms/javascript/cms.js";
import forms from "./swgfl/forms/javascript/forms.js";
import gtm from "./swgfl/javascript/google-tag-manager.js";
import faqs from "./swgfl/faqs/javascript/faqs.js";
import copy from "./swgfl/javascript/copy.js";
import "./swgfl/report/javascript/report.js";

// conflux app
import map from "./reports/javascript/map.js";
import sankey from "./reports/javascript/sankey.js";
import gantt from "./reports/javascript/gantt-timeline.js";

$(() => {
	cookies($(".cookies"));
	security();
	cms($("#form-cms"));
	forms();
	faqs($(".faqs"));

	// click-to-copy buttons (data-copy="<selector>" or "<selector>[attr]"), e.g. the one-time
	// roadmap share link in its success message — server-rendered, so binding here is enough
	copy($("[data-copy]"));

	// LA coverage choropleth (app-level report chart)
	map($(".report__chart-map"));

	// cross-sell Sankey is rendered server-side in PHP; this only adds hover-focus interactivity
	sankey($(".report__chart-sankey"));

	// Roadmap Gantt milestone tooltips
	gantt($("[data-gantt]"));

	// tag manager
	gtm($("html").data("gtm"));
});
